<div class="flex-layout" [class.collapsed]="collapsed">
  <div class="sidebar-top">
  
      <app-branding [collapsed]="collapsed"></app-branding>
  </div>
  <div
  class="toggle-container"
  [class.collapsed]="collapsed"
  [class.expanded]="!collapsed"
   [matTooltip]="!collapsed ? 'Collapse' : 'Expand'"
  matTooltipPosition="right"
  matTooltipClass="custom-tooltip"
>
  <button class="panel-toggle-btn" (click)="toggleCollapse()">
    <mat-icon>{{ collapsed ? 'menu' : 'menu_open' }}</mat-icon>
  </button>
</div>

  <mat-nav-list class="sidebar-list" style="color: black">
    <app-nav-item
      *ngFor="let item of filteredNavItems"
      [item]="item"
      [collapsed]="collapsed"
    >
    </app-nav-item>
  </mat-nav-list>



    <div *ngIf="!collapsed"  style="
    position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  text-align: center;
  ">
      © 2026 <strong>KapitalNex</strong>.
    </div>


</div>
<style>


.toggle-container {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 0;
  flex-shrink: 0;
}

.toggle-container.collapsed {
  justify-content: center;
}

.toggle-container.expanded {
  justify-content: flex-end;
  padding-right: 15px;
}

.panel-toggle-btn {

  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
}

.panel-toggle-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  color: #0060AE;
}
.sidebar-bottom {
  text-align: center;
  padding: 10px;
}



  .app-footer {
  margin-top: auto;
  padding: 10px 0;
  text-align: center;
  font-size: 12px;
  color: #000;
}
  .sidebar-profile-cards .dropdown-item {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }
  .sidebar-profile-cardss .dropdown-item {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }
  .profile-icon {
    font-size: 20px;
  }
  .profile-text {
    font-size: 14px;
  }
  .hide-menu {
    margin: 0;
    padding: 0;
    flex-grow: 1;
    font-size: 1rem;
    color: var(--Text-Primary, #000);
    font-style: normal;
    font-weight: 500;
    line-height: 2.25rem;
    font-family: "Inter", sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .hide-menu:hover {
    color: #fff;
    background-color: #ccc;
    border-radius: 6px;
  }
  .hide-menu.active {
    color: #fff;
    background-color: #ccc;
    border-radius: 8px;
  }
  .sidebar-footer {
    position: relative;
    padding: 0.625rem;
    display: flex;
    justify-content: flex-start;
    border: 1px solid #cdcccc;
    margin: 0.5rem 0.75rem;
    border-radius: 0.375rem;
  }
  .profile-pic {
  width: 2rem;
  height: 2rem;
  margin: 0.5rem;
  border-radius: 50%;
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid black;
}


  .profile-details {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }
  .profile-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: #333;
  }
  .logout-link {
    font-size: 0.8rem;
    color: red;
    text-decoration: none;
    font-weight: 500;
  }
  .logout-link:hover {
    text-decoration: underline;
  }
  .kebab-menu {
    margin-left: auto;
    font-size: 22px;
    cursor: pointer;
    padding: 0 8px;
    display: flex;
    align-items: center;
  }

  .kebab-dropdown {
    position: absolute;
    right: 10px;
    bottom: 50px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    width: 130px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    z-index: 100;
  }
  .sidebar-profile-card {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    padding: 15px;
    transform: translateY(20px);
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease;
    z-index: 999;
  }
  .sidebar-profile-card.open {
    transform: translateY(-5px);
    opacity: 1;
    pointer-events: auto;
  }
  .sidebar-profile-cards {
    position: fixed;
    right: 72%;
    bottom: 90px;
    width: 180px;
    background: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    padding: 10px;
    transform: translateY(20px);
    opacity: 0;
    pointer-events: none;
    transition: all 0.25s ease;
    z-index: 9999;
  }
  .sidebar-profile-cardss {
    position: fixed;
    right: 74%;
    bottom: 90px;
    width: 180px;
    background: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    padding: 10px;
    transform: translateY(20px);
    opacity: 0;
    pointer-events: none;
    transition: all 0.25s ease;
    z-index: 9999;
  }
  .sidebar-profile-cards.open {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }
  .sidebar-profile-cardss.open {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }

  .profile-img-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .sidebar-profile-img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
  }
  .submit-btn {
    margin-top: 1rem;
    width: 100%;
    border: none;
    background-color: #007bff;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
  }
  .submit-btn:hover {
    background-color: #0056b3;
  }

  .edit-icon {
    position: absolute;
    top: 85%;
    left: 60%;
    transform: translate(-50%, -50%);
    width: 24px;
    height: 24px;
    padding: 0;
    min-width: 0;
    border-radius: 50%;
    background: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
  }
  .edit-icon mat-icon {
    font-size: 16px;
    color: #000;
  }
  .edit-icon:hover,
  .edit-icon:focus,
  .edit-icon:active {
    background: none !important;
    box-shadow: none !important;
  }
  .sidebar-profile-name {
    font-weight: bold;
    margin-bottom: 5px;
  }
  .sidebar-profile-email {
    font-size: 0.85rem;
    color: #555;
    margin-bottom: 10px;
  }
  .sidebar-profile-actions button {
    display: block;
    width: 100%;
    margin-bottom: 5px;
    padding: 6px;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .sidebar-profile-cards,
    .sidebar-profile-cardss {
      right: 10px !important;
      bottom: 80px !important;
      width: 160px !important;
      left: auto !important;
    }
    .sidebar-profile-cards.open,
    .sidebar-profile-cardss.open {
      transform: translateY(0);
      opacity: 1;
      pointer-events: auto;
    }
    .sidebar-profile-cards .dropdown-item,
    .sidebar-profile-cardss .dropdown-item {
      gap: 6px;
      font-size: 14px;
    }
  }
</style>
